import { render } from "./MrmView.vue?vue&type=template&id=6230aa8b&scoped=true"
import script from "./MrmView.vue?vue&type=script&lang=js"
export * from "./MrmView.vue?vue&type=script&lang=js"

import "./MrmView.vue?vue&type=style&index=0&id=6230aa8b&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6230aa8b"]])

export default __exports__